import { render, staticRenderFns } from "./CreateCDP.vue?vue&type=template&id=2ad734f0&scoped=true&"
import script from "./CreateCDP.vue?vue&type=script&lang=js&"
export * from "./CreateCDP.vue?vue&type=script&lang=js&"
import style0 from "./CreateCDP.vue?vue&type=style&index=0&id=2ad734f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad734f0",
  null
  
)

export default component.exports